import { useEffect } from "react";
import structuredData from "../structuredData.json";

const DEFAULT_IMAGE = "https://cloudvetx.com/images/cloudvetx-logo.png";
const DEFAULT_IMAGE_ALT = "CloudVetX Logo";

const setMetaAttribute = (selector, attribute, value) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    const nameMatch = selector.match(/meta\[name="([^"]+)"\]/);
    const propertyMatch = selector.match(/meta\[property="([^"]+)"\]/);

    if (nameMatch) {
      element.setAttribute("name", nameMatch[1]);
    }

    if (propertyMatch) {
      element.setAttribute("property", propertyMatch[1]);
    }

    document.head.appendChild(element);
  }

  element.setAttribute(attribute, value);
};

const setCanonical = (url) => {
  let element = document.head.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.setAttribute("href", url);
};

const setStructuredData = () => {
  let element = document.head.querySelector(
    'script[type="application/ld+json"][data-cloudvetx-structured-data="true"]'
  );

  if (!element) {
    element = document.createElement("script");
    element.setAttribute("type", "application/ld+json");
    element.setAttribute("data-cloudvetx-structured-data", "true");
    document.head.appendChild(element);
  }

  element.textContent = JSON.stringify(structuredData);
};

const SEO = ({
  title,
  description,
  canonical,
  image = DEFAULT_IMAGE,
  imageAlt = DEFAULT_IMAGE_ALT,
}) => {
  useEffect(() => {
    document.title = title;

    setMetaAttribute('meta[name="description"]', "content", description);
    setMetaAttribute('meta[property="og:title"]', "content", title);
    setMetaAttribute('meta[property="og:description"]', "content", description);
    setMetaAttribute('meta[property="og:url"]', "content", canonical);
    setMetaAttribute('meta[property="og:image"]', "content", image);
    setMetaAttribute('meta[property="og:image:alt"]', "content", imageAlt);
    setMetaAttribute('meta[name="twitter:title"]', "content", title);
    setMetaAttribute('meta[name="twitter:description"]', "content", description);
    setMetaAttribute('meta[name="twitter:image"]', "content", image);
    setMetaAttribute('meta[property="og:type"]', "content", "website");
    setMetaAttribute('meta[name="twitter:card"]', "content", "summary_large_image");
    setCanonical(canonical);
    setStructuredData();
  }, [canonical, description, image, imageAlt, title]);

  return null;
};

export default SEO;
